function NavMenuBottom() {
  return <div className="navbar fixed-bottom navbar-light zigzag p-md-0"></div>;
}

export default NavMenuBottom;
